export default class PlanSubjectCtrl {

	constructor ($scope, $state, $stateParams, WorkPlanSrv, $mdDialog, $cookies, GlobalConfig, WorkPlanModalSrv) {
		var subjectVm = this

		subjectVm.currentUser = JSON.parse($cookies.get('currentUser'))
		subjectVm.showTable = true
		subjectVm.isFirstTime = 1
		subjectVm.teaching = 1
		subjectVm.swEdit = false
		subjectVm.isFirstTimeRadio = ''
		subjectVm.editOrCreated = 'Planeación exitosa'
		subjectVm.activityName = ''
		subjectVm.workplanTeacherActivityId = null
		subjectVm.showTableActivities = false
		subjectVm.showTableFormation = false
		subjectVm.formPlanSchedule = true
		subjectVm.formFormation = true
		subjectVm.comboboxData = []
		subjectVm.rightTable = []
		subjectVm.activityList = []
		subjectVm.editOneActivity = []
		subjectVm.youngList = []
		subjectVm.activitiesPlanningArray = []
		subjectVm.activitiesTeachersArray = []
		subjectVm.oldPlanningAndManagement = null
		subjectVm.oldFormation = null
		subjectVm.itemActivityRequired = []
		subjectVm.itemFormationRequired = []
		subjectVm.hoursRelation = 0
		subjectVm.buttonDisabled = false
		subjectVm.buttonDisabledModal = false
		// -----------------------------Funciones---------------------------------//
		subjectVm.cleanForm = cleanForm
		subjectVm.editActivitiesPlanning = editActivitiesPlanning
		subjectVm.deleteActivitiesPlanning = deleteActivitiesPlanning
		subjectVm.editActivitiesTeacher = editActivitiesTeacher
		subjectVm.deleteActivitiesTeacher = deleteActivitiesTeacher
		subjectVm.hiddenTable = hiddenTable
		subjectVm.addActivities = addActivities
		subjectVm.addFormation = addFormation
		subjectVm.filterActivity = filterActivity
		subjectVm.saveActivity = saveActivity
		subjectVm.showErrorMessages = showErrorMessages
		subjectVm.hasError = hasError
		subjectVm.validateForm = validateForm
		subjectVm.validateFormActivities = validateFormActivities
		subjectVm.validateFormFormation = validateFormFormation
		subjectVm.showModalFirstTime = showModalFirstTime
		subjectVm.observationRequired = observationRequired
		subjectVm.updateloadTime = updateloadTime
		let iconClasses = [
			'mdi-hardware-keyboard-arrow-down',
			'mdi-hardware-keyboard-arrow-up',
		]

		subjectVm.class = iconClasses[0]
		var post = {
			teacherId   : subjectVm.currentUser.teacherId,
			asignatureId: $stateParams.subjectId,
			workplanId  : subjectVm.currentUser.workplanId,
		}

		subjectVm.isFeedback = subjectVm.currentUser.isFeedback

		var defeaultHoursTeaching = 0

		subjectVm.Math = window.Math

		activate()

		function activate () {
			if (!$stateParams.subjectId) {
				$state.go('workplan.teachingSubjects')
			}

			callServiceCombobox()
		}

		function callServiceEdit() {
			// edit activity
			WorkPlanSrv.getActivityPlanningTeacher.get(post).$promise.then(function(dataReturn) {
				if (dataReturn.status) {
					//console.log("--->", dataReturn)
					if (dataReturn.header.length > 0) {
						subjectVm.editOneActivity = dataReturn
						addValuesEdit()
						getTotalHoursRelation()
						subjectVm.swEdit = true
					}
				} else {
					console.log('Comunications problem with the server')
				}
			}, function(data) {
				console.log(data)
			})
		}

		function getTotalHoursRelation() {
			var hoursPlanned = 0

			//console.log("---", hoursPlanned)
			for (var i in subjectVm.activitiesPlanningArray) {
				//console.log("item--->", subjectVm.activitiesPlanningArray[i])
				if (subjectVm.activitiesPlanningArray[i].itemActivityId === GlobalConfig.minorActivityId.itemRequiredTeaching) {
					//console.log("+++", subjectVm.activitiesPlanningArray[i].hoursPlanned)
					hoursPlanned += subjectVm.activitiesPlanningArray[i].hoursPlanned
				}
			}

			subjectVm.hoursRelation = hoursPlanned
		}

		function callServiceDetailAsignature () {
			// List right table
			return WorkPlanSrv.getDetailAsignaturePlanning.getList(post).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					subjectVm.rightTable = dataReturn.data[0]
					
					if (subjectVm.rightTable.numberStudents == null) {
						subjectVm.rightTable.numberStudents = '0'
					}

					if (subjectVm.activitiesPlanningArray.length === 0 && subjectVm.activitiesTeachersArray.length === 0) {
						if (subjectVm.hoursTeaching) {
							subjectVm.rightTable.loadTime = subjectVm.hoursTeaching
						} else {
							subjectVm.hoursTeaching = subjectVm.rightTable.loadTime
						}
					} else {
						subjectVm.rightTable.loadTime = subjectVm.hoursTeaching
					}

					defeaultHoursTeaching = subjectVm.rightTable.loadTime
				} else {
					console.log('Comunications problem with the server')
				}
			}, function (data) {
				console.log(data)
			})
			//return Promise.resolve(true)
		}

		function callServiceCombobox () {
			// Combobox data
			WorkPlanSrv.getDataFormActivityTeaching.get().$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					subjectVm.comboboxData = dataReturn
					//console.log("Combobox ", dataReturn)
					subjectVm.activityList = subjectVm.comboboxData.listsPlanning.items
					subjectVm.youngList = subjectVm.comboboxData.listsTeachers.items
					subjectVm.directTeaching = GlobalConfig.minorActivityId.directTeaching
					subjectVm.planning = GlobalConfig.minorActivityId.planning
					subjectVm.training = GlobalConfig.minorActivityId.teaching
				} else {
					console.log('Comunications problem with the server')
				}
			}, function (data) {
				console.log(data)
			})
			callServiceDetailAsignature()
				.then(callServiceEdit())
		}

		function addActivityPlanningTeacher(jsonActivity) {
			// Combobox data
			WorkPlanSrv.addActivityPlanningTeacher.save(jsonActivity)
				.$promise.then(function (dataReturn) {
					if (dataReturn.status) {
						if (subjectVm.swEdit)
							subjectVm.activityName = 'modificado'
						else
							subjectVm.activityName = 'creado'

						subjectVm.buttonDisabledModal = false
						showModalActivityCreated()
					} else {
						subjectVm.buttonDisabled = false
						console.log('Comunications problem with the server')
					}
				}, function (data) {
					console.log(data)
				})
		}

		function createJson() {
			subjectVm.buttonDisabled = true

			if (subjectVm.isFirstTime == 1) {
				subjectVm.isFirstTimeRadio = 1
			} else {
				if (subjectVm.isFirstTime == 0) {
					subjectVm.isFirstTimeRadio = 0
				}
			}

			if (subjectVm.swEdit) {
				if (subjectVm.editOneActivity.header[0].workplanTeacherActivityId) {
					subjectVm.workplanTeacherActivityId = subjectVm.editOneActivity.header[0].workplanTeacherActivityId
				}

				subjectVm.editOrCreated = 'EdiciÃ³n exitosa'
			}

			var headerArray = {
				workplanTeacherActivityId: subjectVm.workplanTeacherActivityId,
				hoursPlanned             : (subjectVm.hoursTeaching == 0) ? subjectVm.hoursTeaching : (subjectVm.hoursTeaching * subjectVm.rightTable.groupsTempNum),
				hoursDirectTeaching      : subjectVm.hoursTeaching,
				description              : subjectVm.observation,
				teacherId                : post.teacherId,
				asignatureId             : post.asignatureId,
				workplanId               : post.workplanId,
				isFirstTime              : subjectVm.isFirstTimeRadio,
				activitiesPlanning       : subjectVm.activitiesPlanningArray,
				activitiesTeachers       : subjectVm.activitiesTeachersArray,
				activityId               : parseInt(subjectVm.directTeaching),
				relationship             : (subjectVm.hoursRelation == 0 || subjectVm.hoursTeaching == 0) ? (1 / (1 * subjectVm.rightTable.groupsTempNum)).toFixed(2) : (subjectVm.hoursRelation / (subjectVm.hoursTeaching * subjectVm.rightTable.groupsTempNum)).toFixed(2),
				isFeedbackActivity       : subjectVm.isFeedback,
			}

			addActivityPlanningTeacher(headerArray)
		}

		function addValuesEdit() {
			let index = 0

			if (subjectVm.editOneActivity.header.length) {
				subjectVm.observation = subjectVm.editOneActivity.header[index].description
				subjectVm.hoursTeaching = subjectVm.editOneActivity.header[index].hoursDirectTeaching
				subjectVm.rightTable.loadTime = subjectVm.hoursTeaching
				subjectVm.isFirstTime = subjectVm.editOneActivity.header[0].isFirstTime
				subjectVm.activitiesPlanningArray = subjectVm.editOneActivity.activitiesPlanning.map(aux => {
					if (null === aux.activityId) aux.activityId = parseInt(subjectVm.planning)

					return aux
				})
				subjectVm.showTableActivities = true //Muestro el div oculto de gestiÃ³n
				subjectVm.activitiesTeachersArray = subjectVm.editOneActivity.activitiesTeachers.map(aux => {
					if (null === aux.activityId) aux.activityId = parseInt(subjectVm.training)

					return aux
				})
				subjectVm.showTableFormation = true //Muestro el div oculto de actividades
				defeaultHoursTeaching = subjectVm.hoursTeaching
			}
		}

		function showModalSaveItemRequired() {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.itemActivitiesRequired = subjectVm.itemActivityRequired
					$scope.itemFormationRequired = subjectVm.itemFormationRequired
					$scope.buttonDisabledModal = subjectVm.buttonDisabledModal
					$scope.continue = function() {
						subjectVm.buttonDisabledModal = true
						createJson()
						$mdDialog.hide()
					}
					$scope.close = function() {
						$mdDialog.hide()
					}
				} ],
				template           : require('./subjectSaveItemRequiredModal.html'),
				clickOutsideToClose: false,
			})
		}

		function saveActivity() {
			subjectVm.buttonDisabled = true
			isAllActivityItemRequired()
			isAllFormationItemRequired()

			if (subjectVm.oldPlanningAndManagement) {
				addOldActivities(subjectVm.oldPlanningAndManagement)
			}

			if (subjectVm.itemActivityRequired.length > 0 || subjectVm.itemFormationRequired.length > 0) {
				subjectVm.buttonDisabled = false
				showModalSaveItemRequired()
			} else {
				createJson()
			}
		}

		function showModalActivityCreated() {
			let texts = GlobalConfig.appTexts
			let actionEditOrCreate = texts.createDialog
			let textCreateOrEdit = texts.saved

			if (subjectVm.swEdit) {
				actionEditOrCreate = texts.editDialog
				textCreateOrEdit = texts.modified
			}

			let header = {
				createOrEdit    : actionEditOrCreate,
				textCreateOrEdit: textCreateOrEdit,
				itemName        : subjectVm.rightTable.asignatureName,
				nameModal       : texts.modalTypeName.teachingSubject,
				modalType       : texts.modalTypeId.teachingSubject,
			}

			WorkPlanModalSrv.setVariableSuccessDialog(header)
			WorkPlanModalSrv.successDialog(header).then((promise) => { })
		}

		function hiddenTable() {
			if (subjectVm.class === iconClasses[0]) {
				subjectVm.class = iconClasses[1]
				subjectVm.showTable = true
			} else {
				subjectVm.class = iconClasses[0]
				subjectVm.showTable = false
			}
		}

		function showModalItemRequired(activities) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					if (activities) {
						$scope.itemName = 'Actividades'
						$scope.itemRequired = subjectVm.itemActivityRequired
					} else {
						$scope.itemName = 'Formaciones'
						$scope.itemRequired = subjectVm.itemFormationRequired
					}

					$scope.close = function() {
						$mdDialog.hide()
					}
				} ],
				template           : require('./subjectItemRequiredModal.html'),
				clickOutsideToClose: false,
			})
		}

		function isAllActivityItemRequired() {    
			var enc = false

			subjectVm.itemActivityRequired = []

			for (var i in subjectVm.activityList) {
				enc = false

				if (subjectVm.activityList[i].isRequired === 1) {
					for (var j in subjectVm.activitiesPlanningArray) {
						if (subjectVm.activitiesPlanningArray[j].itemActivityId === subjectVm.activityList[i].idListItem) {
							enc = true
							break
						}
					}

					if (!enc) {
						subjectVm.itemActivityRequired.push(
							{
								itemActivityName: subjectVm.activityList[i].listItemName,
							},
						)
					}
				}
			}
		}

		function isItemRepeat(array, value) {
			for (var index in array) {
				if (array[index].itemActivityName === value) {
					return true
				}
			}

			return false
		}

		function addActivities() {
			// if(!isItemRepeat(subjectVm.activitiesPlanningArray, subjectVm.activityCombo.listItemName)){
			subjectVm.activitiesPlanningArray.push(
				{
					itemActivityId  : subjectVm.activityCombo.idListItem,
					itemActivityName: subjectVm.activityCombo.listItemName,
					hoursPlanned    : subjectVm.hoursPlanned,
					detail          : subjectVm.detail,
					activityId      : parseInt(subjectVm.planning),
					itemRequired    : subjectVm.activityCombo.isRequired,
				},
			)
			//}

			getTotalHoursRelation()

			subjectVm.activityCombo = null
			subjectVm.hoursPlanned = null
			subjectVm.detail = null
			subjectVm.showTableActivities = true //Muestro el div oculto de gestión
			subjectVm.oldPlanningAndManagement = null
			isAllActivityItemRequired()

			if (subjectVm.itemActivityRequired.length > 0)
				showModalItemRequired(true)
		}

		function addOldActivities(planningAndManagement) {
			subjectVm.activitiesPlanningArray.push(
				{
					itemActivityId  : planningAndManagement.itemActivityId,
					itemActivityName: planningAndManagement.itemActivityName,
					hoursPlanned    : planningAndManagement.hoursPlanned,
					detail          : planningAndManagement.detail,
					activityId      : parseInt(planningAndManagement.activityId),
					itemRequired    : subjectVm.activityCombo.isRequired,
				},
			)

			getTotalHoursRelation()

			subjectVm.activityCombo = null
			subjectVm.hoursPlanned = null
			subjectVm.detail = null
			subjectVm.showTableActivities = true //Muestro el div oculto de gestión
			subjectVm.oldPlanningAndManagement = null
		}

		function isAllFormationItemRequired() {      
			var enc = false

			subjectVm.itemFormationRequired = []

			for (var i in subjectVm.youngList) {
				enc = false

				if (subjectVm.youngList[i].isRequired === 1) {
					for (var j in subjectVm.activitiesTeachersArray) {
						if (subjectVm.activitiesTeachersArray[j].itemActivityId === subjectVm.youngList[i].idListItem) {
							enc = true
							break
						}
					}

					if (!enc) {
						subjectVm.itemFormationRequired.push(
							{
								itemActivityName: subjectVm.youngList[i].listItemName,
							},
						)
					}
				}
			}
		}

		function addFormation() {
			if (!isItemRepeat(subjectVm.activitiesTeachersArray, subjectVm.kindOfYoung.listItemName)) {
				subjectVm.activitiesTeachersArray.push(
					{
						itemActivityId   : subjectVm.kindOfYoung.idListItem,
						itemActivityName : subjectVm.kindOfYoung.listItemName,
						hoursPlanned     : subjectVm.hoursDedicated,
						itemActivityValue: subjectVm.numberOfStudents,
						detail           : subjectVm.activityOfFa,
						activityId       : parseInt(subjectVm.training),
						itemRequired     : subjectVm.kindOfYoung.isRequired,
					},
				)
			}

			subjectVm.kindOfYoung = null
			subjectVm.hoursDedicated = null
			subjectVm.numberOfStudents = null
			subjectVm.activityOfFa = null
			subjectVm.showTableFormation = true //Muestro el div oculto de actividades
			subjectVm.oldFormation = null
			isAllFormationItemRequired()

			if (subjectVm.itemFormationRequired.length > 0)
				showModalItemRequired(false)
		}

		function addOldFormation(formationList) {
			subjectVm.activitiesTeachersArray.push(
				{
					itemActivityId   : formationList.itemActivityId,
					itemActivityName : formationList.itemActivityName,
					hoursPlanned     : formationList.hoursPlanned,
					itemActivityValue: formationList.itemActivityValue,
					detail           : formationList.detail,
					activityId       : parseInt(formationList.training),
					itemRequired     : subjectVm.kindOfYoung.isRequired,
				},
			)

			subjectVm.kindOfYoung = null
			subjectVm.hoursDedicated = null
			subjectVm.numberOfStudents = null
			subjectVm.activityOfFa = null
			subjectVm.showTableFormation = true //Muestro el div oculto de actividades
			subjectVm.oldFormation = null
		}

		function editActivitiesPlanning(planningAndManagement) {
			//VERIFICA QUE NO ESTE UN REGISTRO EN LOS CAMPOS DE AGREGAR
			if (subjectVm.oldPlanningAndManagement) {
				addOldActivities(subjectVm.oldPlanningAndManagement)
			}

			for (var index in subjectVm.activityList) {
				if (subjectVm.activityList[index].idListItem == planningAndManagement.itemActivityId) {
					subjectVm.activityCombo = subjectVm.activityList[index]
				}
			}

			subjectVm.hoursPlanned = planningAndManagement.hoursPlanned
			subjectVm.detail = planningAndManagement.detail
			let idx = subjectVm.activitiesPlanningArray.indexOf(planningAndManagement)

			subjectVm.activitiesPlanningArray.splice(idx, 1)
			subjectVm.oldPlanningAndManagement = planningAndManagement

			if (subjectVm.activitiesPlanningArray == 0) {
				subjectVm.showTableActivities = false
			}
		}

		function editActivitiesTeacher(formationList) {
			//VERIFICA QUE NO ESTE UN REGISTRO EN LOS CAMPOS DE AGREGAR
			if (subjectVm.oldFormation) {
				addOldFormation(subjectVm.oldFormation)
			}

			for (var index in subjectVm.youngList) {
				if (subjectVm.youngList[index].idListItem == formationList.itemActivityId) {
					subjectVm.kindOfYoung = subjectVm.youngList[index]
				}
			}

			subjectVm.hoursDedicated = formationList.hoursPlanned
			subjectVm.numberOfStudents = formationList.itemActivityValue
			subjectVm.activityOfFa = formationList.detail
			let idx = subjectVm.activitiesTeachersArray.indexOf(formationList)

			subjectVm.activitiesTeachersArray.splice(idx, 1)
			subjectVm.oldFormation = formationList

			if (subjectVm.activitiesTeachersArray == 0) {
				subjectVm.showTableFormation = false
			}
		}

		function deleteActivitiesPlanning (planningAndManagement) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.subjectName = planningAndManagement.itemActivityName
					$scope.close = function() {
						$mdDialog.hide()
					}
					$scope.deleteActivitiesPlanning = function() {
						if (planningAndManagement.itemActivityId === GlobalConfig.minorActivityId.itemRequiredTeaching) {
							subjectVm.hoursRelation -= planningAndManagement.hoursPlanned
						}

						let idx = subjectVm.activitiesPlanningArray.indexOf(planningAndManagement)

						subjectVm.activitiesPlanningArray.splice(idx, 1)

						if (subjectVm.activitiesPlanningArray.length == 0) {
							subjectVm.showTableActivities = false
						}

						$mdDialog.hide()
					}
				} ],
				template           : require('./subjetDeletedModal.html'),
				clickOutsideToClose: false,
			})
		}

		function filterActivity(item) {
			for (var x in subjectVm.activitiesPlanningArray) {
				if (subjectVm.activitiesPlanningArray[x].itemActivityId == item.idListItem) {
					return false
				}
			}

			return true
		}

		function deleteActivitiesTeacher (formationList) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.subjectName = formationList.itemActivityName
					$scope.close = function() {
						$mdDialog.hide()
					}
					$scope.deleteActivitiesTeacher = function() {
						let idx = subjectVm.activitiesTeachersArray.indexOf(formationList)

						subjectVm.activitiesTeachersArray.splice(idx, 1)

						if (subjectVm.activitiesTeachersArray.length == 0) {
							subjectVm.showTableFormation = false
						}

						$mdDialog.hide()
					}
				} ],
				template           : require('./subjetDeletedActivitiesTeacherModal.html'),
				clickOutsideToClose: false,
			})
		}

		function cleanForm(form) {
			form.$setPristine()
			form.$setUntouched()
		}

		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}

		function showErrorMessages(input) {
			return input.$dirty || input.$touched
		}

		function validateForm(form) {
			return form.$invalid
		}

		function validateFormActivities(formActivities) {
			return formActivities.$invalid
		}

		function validateFormFormation(formFormation) {
			return formFormation.$invalid
		}

		function showModalFirstTime() {
			post.assignaturePublicId = subjectVm.rightTable.assignaturePublicId
			post.semId = subjectVm.rightTable.semId
			post.typen = subjectVm.rightTable.type
			post.id_mod = subjectVm.rightTable.id_modality
			let postVal = post

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					const firstTimeVm = this

					firstTimeVm.postValues = postVal
					firstTimeVm.datos = {}
					//funciones
					firstTimeVm.close = close
					firstTimeVm.getPreviusPlanning = getPreviusPlanning

					function close() {
						$mdDialog.hide()
						subjectVm.isFirstTime = 1
					}

					function getPreviusPlanning() {
						WorkPlanSrv.getPreviusPlanning.get(firstTimeVm.postValues).$promise.then(function(dataReturn) {
							if (dataReturn.status) {
								firstTimeVm.datos = dataReturn.data

								if (!isEmptyJSON(firstTimeVm.datos)) {
									setValues()
								}
							}
						}, function (data) {
							console.log(data)
						})

						$mdDialog.hide()
					}

					function setValues() {
						let index = 0

						subjectVm.observation = firstTimeVm.datos.header[index].description
						subjectVm.hoursTeaching = firstTimeVm.datos.header[index].hoursPlanned
						subjectVm.activitiesPlanningArray = firstTimeVm.datos.activitiesPlanning.map(aux => {
							aux.activityId = parseInt(subjectVm.planning)

							return aux
						})
						subjectVm.showTableActivities = true //Muestro el div oculto de gestión
						subjectVm.activitiesTeachersArray = firstTimeVm.datos.activitiesTeachers.map(aux => {
							aux.activityId = parseInt(subjectVm.training)

							return aux
						})
						subjectVm.showTableFormation = true //Muestro el div oculto de actividades
					}
				} ],
				controllerAs       : 'firstTimeVm',
				template           : require('./subjetFirstTimeModal.html'),
				clickOutsideToClose: false,
			})
		}

		function observationRequired() {
			return subjectVm.hoursTeaching != defeaultHoursTeaching
		}

		function isEmptyJSON(obj) {
			if (obj != null) { 
				return false 
			}

			//for(var i in obj) { return false; }
			return true
		}

		function updateloadTime(observationInput) {
			subjectVm.rightTable.loadTime = subjectVm.hoursTeaching
			observationInput.$setTouched()
		}
	}

}

PlanSubjectCtrl.$inject = [ '$scope', '$state', '$stateParams', 'WorkPlanSrv', '$mdDialog', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/teaching/subjects/plan/planSubjectCtrl.js